import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 10,
		width: 14,
		height: 10,
		rx: 2
	}), /* @__PURE__ */ _jsx("path", { d: "M8 10V7a4 4 0 0 1 8 0v3" })]
});
export default SvgLock;
